import { useState } from "react";
import type { FaqItem } from "@/types/content";

interface FaqAccordionProps {
  items: FaqItem[];
  defaultOpenId?: string;
}

export default function FaqAccordion({ items, defaultOpenId }: FaqAccordionProps) {
  const [openId, setOpenId] = useState<string | null>(defaultOpenId ?? null);

  return (
    <div className="flex flex-col gap-3">
      {items.map((item) => {
        const open = openId === item.id;
        return (
          <div
            key={item.id}
            className={`rounded-lg border bg-background-50 transition-colors ${
              open ? "border-primary-300" : "border-background-200"
            }`}
          >
            <button
              type="button"
              onClick={() => setOpenId(open ? null : item.id)}
              aria-expanded={open}
              className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left md:px-5"
            >
              <span className="flex items-start gap-3">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-900">
                  <i className="ri-question-line text-xs"></i>
                </span>
                <span className="font-label text-sm font-medium text-foreground-900 md:text-base">
                  {item.question}
                </span>
              </span>
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600">
                <i className={open ? "ri-subtract-line" : "ri-add-line"}></i>
              </span>
            </button>
            {open ? (
              <div className="px-4 pb-4 md:px-5">
                <p className="border-t border-background-200 pt-3 pl-8 text-sm leading-relaxed text-foreground-600">
                  {item.answer}
                </p>
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}